import { Routes, Route } from "react-router-dom";
import React from 'react'
import NavBar from "./components/navbar";
import Home from "./features/Home";
import Dashboard from "./features/dashboard";
import User from "./features/users";
import Medicines from "./features/medicines";
import MedicinesAdd from "./features/medicines/MedicinesAdd";
import MedicinesOnesView from "./features/medicines/components/MedicinesOnesView";
import MedicinesUpdate from "./features/medicines/MedicinesUpdate";
import CreateArticle from "./features/articles/pages/CreateArticle";
import MyArticles from "./features/articles/pages/PersonalArticles";
import AdminAllArticles from "./features/articles/pages/AdminArticles";
import MedicinesFilterByChanneling from "./features/medicines/components/MedicinesFilterByChanneling";
import AddChanneling from "./features/channeling/components/AddChanneling";
import ChannelingList from "./features/channeling/components/ChannelingList";
import ViewChanneling from "./features/channeling/components/ViewChanneling";
import AddKey from "./features/channeling/components/AddKey";
import UpdateChanneling from "./features/channeling/components/UpdateChanneling";
import Login from "./features/users/components/Login";
import Register from "./features/users/components/Register";
import Update from "./features/users/components/Update";
import DoctorView from "./features/channeling/components/DoctorView";
import Articles from "./features/articles/pages/Articles";
import EditArticle from "./features/articles/pages/EditArticle";
import AllUsers from "./features/admin/components/AllUsers";
import AdminLogin from "./features/admin/components/AdminLogin";



function App() {
  return (
    <>
      <NavBar/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/medicines" element={<Medicines />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/userprofile" element={<User />} />
        <Route path="/user/update/:id" element={<Update />} />
        <Route path="/medicines/add" element={<MedicinesAdd />} />
        <Route path="/medicines/view/:id" element={<MedicinesOnesView />} />
        <Route path="/medicines/update/:id" element={<MedicinesUpdate />} />
        <Route path="/medicines/channeling/:id" element={<MedicinesFilterByChanneling />} />
        <Route path="/articles/new" element={<CreateArticle />} />
        <Route path="/articles/user/articles" element={<MyArticles />} />
        <Route path="/articles/all" element={<AdminAllArticles />} />
        <Route path="/channeling" element={<ChannelingList />} />
        <Route path="/addchanel" element={<AddChanneling />} />
        <Route path="/viewchanneling/:id" element={<ViewChanneling />} />
        <Route path="/updatechanneling/:id" element={<UpdateChanneling />} />
        <Route path="/addkey" element={<AddKey />} />
        <Route path="/doctorview/:tid/:oid" element={<DoctorView />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/articles/edit/:id" element={<EditArticle />} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/allusers" element={<AllUsers />} />
      </Routes>
    </>
  )
}

export default App
